export default {
  name: "Application Documents",
  pageInfo: {
    text: "Below, you will find a summary of the documents that you have uploaded to this application throughout the form. You may also add and categorize additional supplemental documents below. </br></br>Reminder: Employers must provide the CO with proof of workers' compensation insurance coverage, including the name of the insurance carrier, the insurance policy number, and proof of insurance for the dates of need, or, if appropriate, proof of State law coverage. If the insurance will expire during the period of need, employers should upload an attestation that the insurance will be renewed.",

    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          machine_name: "files",
          widget: "application_documents",
          validate: [],
          checkDocuments: [
            "e6_is_work_contracts_complete",
            "e7_is_mspa_complete_file",
            "e8_is_surety_bond_complete",
          ],
          modal: {
            machine_name: "application_documents",
            name: "Application Documents",
            widget: "file_upload",
            label:
              "<span>Read and agree to all the application terms, assurances, and obligations contained in <u>Appendix A</u> and attach a signed and dated copy with this application.</span>",
            fileTypes: [".pdf", ".png", ".jpg"],
          },
        },
      ],
    },
  ],
};
